<template>
    <div class="screen">
        <div class="screen__inner--last">
            <div class="screen__line">
                <img
                    :src="quizBlueLine"
                    alt=""
                />
            </div>
            <div class="screen__img">
                <img
                    :src="greenCheckMark"
                    alt=""
                />
            </div>
            <h3 class="screen__title heading-tertiary">{{ $t('__quiz_screen_7_title') }}</h3>
        </div>
        <button
            class="screen__button screen__button--center btn btn-primary"
            @click="handleRestart"
        >
            {{ $t('__quiz_screen_7_start_over') }}
        </button>
        <div class="screen__background">
            <img
                :src="questionIcon"
                alt=""
            />
        </div>
    </div>
</template>

<script>
import quizBlueLine from '../../assets/svg/quiz/quiz-blue-line.svg';
import greenCheckMark from '../../assets/svg/quiz/green-check-mark.svg';
import questionIcon from '../../assets/svg/quiz/question.svg';

export default {
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            quizBlueLine,
            greenCheckMark,
            questionIcon,
        };
    },
    methods: {
        handleRestart() {
            this.$emit('restart');
        },
    },
};
</script>
